import React from "react";
import styled from "styled-components";
import { Tag } from "antd";
import { Icon, IconContainer } from "./styledComponents";

type TagSize = "small" | "default";

const tagSizeStyles: Record<TagSize, string> = {
  small: "font-size: 10px; padding: 2px 5px;",
  default: "font-size: 12px; padding: 3px 7px;",
};

const StyledTag = styled(Tag)<{
  textColor?: string;
  isClickable?: boolean;
  hideMargin?: boolean;
  tagSize: TagSize;
}>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  font-family: "Apercu";
  ${({ tagSize }): string => tagSizeStyles[tagSize]};
  color: ${({ textColor }): string => textColor || "white"} !important;
  cursor: ${({ isClickable }): string => (isClickable ? "pointer" : "default")};
  ${({ hideMargin }): string =>
    hideMargin ? "margin-inline-end: 0px !important;" : ""}
  &:hover {
    ${({ isClickable }): string =>
      isClickable ? "transform: scale(1.1);" : ""};
  }
`;

const StyledIconContainer = styled(IconContainer)`
  margin-right: 8px;
`;

export const CompassTag = ({
  tagKey,
  displayValue,
  bg,
  color,
  size = "default",
  shouldDisplayKey = false,
  isClickable = false,
  hideMargin = false,
  icon,
  handleClick,
}: TagProps): JSX.Element => {
  return (
    <StyledTag
      color={bg}
      textColor={color}
      tagSize={size}
      isClickable={isClickable}
      hideMargin={hideMargin}
      onClick={handleClick}
    >
      {icon && (
        <StyledIconContainer size={icon.size} m={1} p={1}>
          <Icon src={icon.src} alt="tag-icon" />
        </StyledIconContainer>
      )}
      {shouldDisplayKey ? tagKey : displayValue}
    </StyledTag>
  );
};

export interface TagProps {
  tagKey: string;
  color: string;
  bg: string;
  displayValue: string;
  size?: TagSize;
  shouldDisplayKey?: boolean;
  isClickable?: boolean;
  hideMargin?: boolean;
  icon?: { src: string; size: number };
  handleClick?: <P>(param: P) => void;
}
